module.exports = __webpack_public_path__ + "static/media/f2.331d1138.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/Documentation/images/f2.jpg
// module id = 395
// module chunks = 0